import { render } from "./GiftsItem.vue?vue&type=template&id=b72c971a"
import script from "./GiftsItem.vue?vue&type=script&lang=js"
export * from "./GiftsItem.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__